import { useState } from "react";
import LoadingExperience from "./LoadingExperience";

function csrfToken() {
  return document.querySelector('meta[name="csrf-token"]')?.content;
}

export default function RequestForm({ createPath }) {
  const [domain, setDomain] = useState("");
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [errors, setErrors] = useState({});
  const [statusPath, setStatusPath] = useState(null);

  const submit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    setErrors({});

    try {
      const response = await fetch(createPath, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json", "X-CSRF-Token": csrfToken() },
        body: JSON.stringify({ domain, email }),
      });
      const data = await response.json();

      if (response.ok) {
        if (data.status === "ready") {
          window.location.href = data.demo_path;
        } else {
          setStatusPath(`/d/${data.token}/status`);
        }
      } else {
        setErrors(data.errors || { base: ["Something went wrong. Please try again."] });
        setSubmitting(false);
      }
    } catch {
      setErrors({ base: ["We couldn't reach the server. Please try again."] });
      setSubmitting(false);
    }
  };

  if (statusPath) {
    return <LoadingExperience statusPath={statusPath} />;
  }

  const fieldErrors = (key) => (errors[key] || []).join(", ");

  return (
    <form onSubmit={submit} className="text-left" noValidate>
      <label className="block mb-4">
        <span className="block text-sm font-semibold mb-1.5">Your Shopify store</span>
        <input
          type="text"
          required
          placeholder="your-store.myshopify.com"
          value={domain}
          onChange={(e) => setDomain(e.target.value)}
          className="w-full rounded-xl border border-ink/15 bg-white px-4 py-3 outline-none transition focus:border-sky-deep focus:ring-4 focus:ring-sky-wash placeholder:text-ink/30"
          autoComplete="off"
          spellCheck="false"
        />
        {fieldErrors("myshopify_domain") && <span className="mt-1 block text-sm text-red-600">{fieldErrors("myshopify_domain")}</span>}
      </label>

      <label className="block mb-5">
        <span className="block text-sm font-semibold mb-1.5">Work email</span>
        <input
          type="email"
          required
          placeholder="you@brand.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full rounded-xl border border-ink/15 bg-white px-4 py-3 outline-none transition focus:border-sky-deep focus:ring-4 focus:ring-sky-wash placeholder:text-ink/30"
        />
        {fieldErrors("email") && <span className="mt-1 block text-sm text-red-600">{fieldErrors("email")}</span>}
      </label>

      {fieldErrors("base") && <p className="mb-4 text-sm text-red-600">{fieldErrors("base")}</p>}

      <button type="submit" className="btn-primary w-full text-base" disabled={submitting}>
        {submitting ? "Starting…" : "Build my Simple Bundles"}
        {!submitting && <span aria-hidden="true">→</span>}
      </button>

      <p className="mt-4 text-center text-xs text-ink-soft">
        Free · No app install · Ready in ~2 minutes
      </p>
    </form>
  );
}
